'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _ArrowDownFilled = require('./lib/icons/ArrowDownFilled');
  
  
  var _default = _ArrowDownFilled;
  exports.default = _default;
  module.exports = _default;